import { Dispatch, SetStateAction, useCallback } from 'react';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import useSocketEvent from 'services/socketService/hooks/useSocketEvent';
import { DataRoomFileProccessingEventData } from 'services/socketService/socketEventData';
import { LISTEN_EVENTS } from 'services/socketService/socketEventNames';

const useUpdateProcessingFile = (
  currentlyDisplayedNodes: DataRoomNode[],
  setCurrentlyDisplayedNodes: Dispatch<SetStateAction<DataRoomNode[]>>,
) => {
  const updateIsProcessedSuccessfully = useCallback(
    (eventData: DataRoomFileProccessingEventData) => {
      const { dataRoomNodeId } = eventData;

      if (currentlyDisplayedNodes.some(({ _id }) => _id === dataRoomNodeId)) {
        setCurrentlyDisplayedNodes((prev) =>
          prev.map((node) =>
            dataRoomNodeId !== node._id
              ? node
              : {
                  ...node,
                  isProcessedSuccessfully: true,
                  failedConversionToPdf: false,
                },
          ),
        );
      }
    },
    [currentlyDisplayedNodes, setCurrentlyDisplayedNodes],
  );

  useSocketEvent(
    LISTEN_EVENTS.NODE_PROCESSED_SUCCESSFULLY,
    updateIsProcessedSuccessfully,
  );
};

export default useUpdateProcessingFile;
